var map = {
	"./en": [
		"348e"
	],
	"./en.ts": [
		"348e"
	],
	"./es": [
		"4dbc",
		"chunk-2d0cc7e7"
	],
	"./es.ts": [
		"4dbc",
		"chunk-2d0cc7e7"
	],
	"./fr": [
		"8995",
		"chunk-2d0df2d3"
	],
	"./fr.ts": [
		"8995",
		"chunk-2d0df2d3"
	],
	"./ms": [
		"372a",
		"chunk-2d0ba4c9"
	],
	"./ms.ts": [
		"372a",
		"chunk-2d0ba4c9"
	],
	"./pt": [
		"76d1",
		"chunk-2d0d7862"
	],
	"./pt.ts": [
		"76d1",
		"chunk-2d0d7862"
	],
	"./th": [
		"0d6e",
		"chunk-2d0af119"
	],
	"./th.ts": [
		"0d6e",
		"chunk-2d0af119"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "81b7";
module.exports = webpackAsyncContext;